export default __webpack_public_path__ + "static/media/bg-bottomMb.5d2ce426.png";